import { isAthletePayload, type JwtPayload } from '@/lib/auth/jwt'
import { getSessionTokenPayload } from '@/utils/auth'

import type { AccountType } from './dictionaries'

export function accountTypeFromRoles(
  roles?: string[] | null,
  payload?: JwtPayload | null
): AccountType {
  if (roles?.includes('USER_ROLE_CLUB')) {
    return isAthletePayload(payload) ? 'athlete' : 'club'
  }
  if (roles?.includes('USER_ROLE_AGENT')) return 'agent'
  return 'fan'
}

export function currentAccountType(): AccountType {
  const payload = getSessionTokenPayload()
  return accountTypeFromRoles(payload?.roles, payload)
}

export function accountTypeFromEntityType(
  entityType?: string | null
): AccountType {
  if (entityType === 'CLUB') return 'club'
  if (entityType === 'ATHLETE') return 'athlete'
  return 'fan'
}
